import { IconStyle } from '@nextgen-web-framework/all';
import { ComponentType } from '../../registries/types/propTypes';
import {
  ProfileSectionPropsTypes,
  ProfileListInterface,
  MePanelProps,
} from '../../../components/MePanel/types/propsTypes';
import { CMSDataType } from '../../../utils/common';
const transformMePanel = (data: CMSDataType) => {
  const { sections } = data || {};
  const sectionData = sections?.map((item: CMSDataType) => {
    const { items, title } = item || {};
    const subItemDetail = items?.map((subItem: CMSDataType) => {
      const { component, title, link, icon: { url = '' } = {}, icon_type } = subItem || {};
      return {
        component,
        label: title,
        reDirectUrl: link?.url,
        target: link?.target ?? '',
        imageSrc: url,
        iconName: icon_type?.faicon,
        iconType: IconStyle.REGULAR,
      } as ProfileListInterface;
    });
    return {
      profileData: subItemDetail,
      title: title,
    } as ProfileSectionPropsTypes;
  });
  return {
    componentType: ComponentType.me_panel,
    data: sectionData,
  } as MePanelProps;
};

export default transformMePanel;
